import { AnimatePresence } from 'framer-motion';
import { Box } from '@/ui';
import { getStars } from './lib';
import { Star } from './Star';

const stars = getStars({ seed: String(Math.random()) });

export const StaticBackground = () => {
  return (
    <Box
      bg="var(--experience-page-background)"
      inset="0"
      pointerEvents="none"
      pos="fixed"
      zIndex={-1}
    >
      <AnimatePresence>
        {stars.map((star, index) => (
          <Star fillColor="#fff" key={index} {...star} />
        ))}
      </AnimatePresence>
    </Box>
  );
};
